import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQ } from "../../mock";
import Reveal from "./Reveal";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FaqSection() {
  return (
    <section id="faq" className="py-24 lg:py-32 bg-[#faf7f0]" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-[#c4703f]">FAQ</span>
          <h2 className="font-display text-4xl lg:text-5xl font-semibold text-[#13261c] mt-3 leading-[1.05]">Vos questions, nos réponses</h2>
          <p className="mt-5 text-[#5a6158] leading-relaxed">Vous ne trouvez pas votre réponse ? Notre équipe malouine vous répond du lundi au samedi.</p>
          <Link to="/faq" data-testid="faq-see-all" className="mt-6 inline-flex items-center gap-2 font-bold text-[#c4703f] hover:text-[#13261c] transition-colors">Voir toute la FAQ <ArrowRight className="w-4 h-4" /></Link>
        </Reveal>
        <Reveal className="lg:col-span-8" delay={100}>
          <Accordion type="single" collapsible defaultValue="item-0" className="space-y-3">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border border-[#e6dcc8] rounded-2xl px-6 bg-[#f6f1e7] data-[state=open]:bg-white data-[state=open]:shadow-[0_20px_40px_-25px_rgba(19,38,28,0.35)] transition-[background-color,box-shadow]">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left text-[17px] font-bold text-[#13261c] hover:no-underline py-5">{f.q}</AccordionTrigger>
                <AccordionContent className="text-[15px] text-[#5a6158] leading-relaxed pb-5">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
